<template>
  <Screen>
    <AppBar title="Sliders" :showBackButton="false">
      <inertia-link
        :href="$route('admin.sliders.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="Sliders" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <template v-if="data.data.length > 0">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th>Image</th>
                  <th>Redirect</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Updated</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in data.data" :key="item.id">
                  <td>
                    {{ i + 1 }}
                  </td>
                  <th>{{ item.type }}</th>
                  <td>
                    <img v-lazy="item.image_url" class="img-rounded-sm" />
                  </td>
                  <td>
                    <a
                      v-if="item.redirect_url"
                      :href="item.redirect_url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="font-weight-bold"
                      v-text="item.redirect_url"
                    ></a>
                    <span v-else>-</span>
                  </td>
                  <th>
                    <StatusSwitch
                      :dataid="item.id"
                      :status="item.is_active"
                      action="sliderStatus"
                    />
                  </th>
                  <td>{{ item.created_at_human }}</td>
                  <td>{{ item.updated_at_human }}</td>
                  <td>
                    <inertia-link
                      class="btn btn-sm btn-light"
                      :href="
                        $route('admin.sliders.edit', {
                          id: item.id,
                        })
                      "
                      >Edit</inertia-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <NoData title="No sliders added yet" v-else>
          <inertia-link
            :href="$route('admin.sliders.create')"
            class="btn btn-primary"
            ><i class="fa fa-plus"></i> Add new</inertia-link
          >
        </NoData>
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  mounted() {},
  methods: {
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
        })
      );
    },
  },
  computed: {},
};
</script>
